import { render, staticRenderFns } from "./MyPrincipal.vue?vue&type=template&id=70738c99&scoped=true"
import script from "./MyPrincipal.vue?vue&type=script&lang=js"
export * from "./MyPrincipal.vue?vue&type=script&lang=js"
import style0 from "./MyPrincipal.vue?vue&type=style&index=0&id=70738c99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70738c99",
  null
  
)

export default component.exports